export const MANAGERS_NODE = 'managers';

export const CLOUD_FUNCTIONS = {
  CREATE_MANAGER: 'managerCreate',
};
